import { fromStoredPhone } from '@/lib/phoneMx';
import type { Store } from '../api/useRetailOrg';

/** Estado del formulario de tienda; todo es texto porque así lo editan los inputs. */
export interface StoreForm {
    zoneId: string;
    code: string;
    name: string;
    address1: string;
    city: string;
    state: string;
    zipCode: string;
    lat: string;
    lng: string;
    phone: string;
}

// Adelanta lo que type-kit aún no publica: location nullable y managedByIntegration.
type StoreLike = Omit<Store, 'location'> & {
    location: { lat: number; lng: number } | null;
    managedByIntegration?: boolean;
};

/** Llena el formulario desde una tienda; sin coordenada deja lat y lng vacíos. */
export function storeToForm(s: Store): StoreForm {
    const store = s as unknown as StoreLike;
    return {
        zoneId: store.zoneId ?? '',
        code: store.code,
        name: store.name,
        address1: store.address.address1 ?? '',
        city: store.address.city ?? '',
        state: store.address.state ?? '',
        zipCode: store.address.zipCode ?? '',
        lat: store.location ? String(store.location.lat) : '',
        lng: store.location ? String(store.location.lng) : '',
        phone: fromStoredPhone(store.phone),
    };
}

/** Una tienda que administra la integración del retailer no se edita desde el backoffice. */
export function canEditStore(s: Store): boolean {
    return (s as unknown as StoreLike).managedByIntegration !== true;
}
